import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      title: "Livraison rapide",
      description: "Livraison rapide partout au Maroc, pour recevoir vos produits en toute simplicité, où que vous soyez.",
      icon: "/assets/images/features/delivery.png", // Update with your path
    },
    {
      title: "Qualité Garantie",
      description: "Tous nos produits sont sélectionnés avec soin pour garantir leur qualité, avec un engagement clair en matière de garantie.",
      icon: "/assets/images/features/guarantee.png",
    },
    {
        title: "Paiement à la livraison",
        description: "Payez en toute sécurité en espèces au moment de la réception de votre commande chez vous.",
        icon: "/assets/images/features/payment.png",
    },
    {
      title: "Offre exceptionnelle",
      description: "Profitez de nos promotions exclusives, remises spéciales et offres limitées sur une large sélection de produits.",
      icon: "/assets/images/features/promotions.png",
    },
    {
      title: "Service Après Vente",
      description: "Disponible en magasin 7j/7, avec assistance rapide, conseils techniques et prise en charge de vos garanties.",
      icon: "/assets/images/features/service.png",
    },
  ];

  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center p-6 border border-gray-200 rounded-xl bg-white transition-shadow hover:shadow-md"
            >
              {/* Icon Container */}
              <div className="w-24 h-24 mb-6 rounded-full bg-gray-100 flex items-center justify-center">
                <img 
                  src={feature.icon} 
                  alt={feature.title} 
                  className="w-12 h-12 object-contain"
                />
              </div>

              {/* Text Content */}
              <h3 className="text-lg font-bold text-gray-900 mb-3 leading-tight">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;